import { createRouter, createWebHistory } from 'vue-router';

import testList from './test';
import userList from './kids/user';
import commonList from './kids/common';
import paymentList from './kids/payment';
import priviteList from './kids/privite';
import invoiceList from './kids/invoice';

const router = createRouter({
  history: createWebHistory('/'),
  routes: [
    ...testList,
    ...userList,
    ...commonList,
    ...paymentList,
    ...priviteList,
    ...invoiceList,
    {
      path: '/404',
      name: '404',
      component: () => import('@/views/NotFound.vue'),
      meta: {
        disabled: 1,
      },
    },
    {
      path: '/:pathMatch(.*)',
      component: () => import('@/views/NotFound.vue'),
      meta: {
        disabled: 1,
      },
    },
  ],
});

export default router;
